import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';


@Component({
  selector: 'sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  activeRoute: string = '';
  menuItems = [
    {
      name: 'Dashboard',
      icon: 'assets/icons/dashboard.svg',
      url: '/dashboard',
      color: '#009FE0',
    },
    {
      name: 'Certificates',
      icon: 'assets/icons/certificates.svg',
      url: '/certificates',
      color: '#EA5EFF',
    },
    {
      name: 'Key Rotation',
      icon: 'assets/icons/certificates.svg',
      url: '/key-rotation',
      color: '#6e5effff',
    },
    {
      name: 'Pen Testing',
      icon: 'assets/icons/discover.svg',
      url: '/pen',
      color: '#00E0AA',
    },
    {
      name: 'SSL Guide',
      icon: 'assets/icons/manage.svg',
      url: '/guide',
      color: '#D46729',
    },

     {
      name: 'My Orders',
      icon: 'assets/icons/transaction.svg',
      url: '/my-orders',
      color: 'white',
    }


    // {
    //   name: 'Reports',
    //   icon: 'assets/icons/reports.svg',
    //   url: '/reports',
    //   color: '#FF5667',
    // },
    // {
    //   name: 'Settings',
    //   icon: 'assets/icons/settings.svg',
    //   url: '/settings',
    //   color: '#FDC723',
    // },
  ];
  constructor(public router: Router, private authService: AuthService) {}

  ngOnInit(): void {
    const user = this.authService.getUser();
    if (user?.role === 'design_partner') {
      const ordersIndex = this.menuItems.findIndex((item) => item.url === '/my-orders');
      const insertAt = ordersIndex >= 0 ? ordersIndex + 1 : this.menuItems.length;
      this.menuItems.splice(insertAt, 0,
        {
          name: 'Domains',
          icon: 'assets/icons/certificates.svg',
          url: '/domains',
          color: '#00D4AA',
        },
        {
          name: 'Feedback',
          icon: 'assets/icons/reports.svg',
          url: '/feedback',
          color: '#289DD2',
        }
      );
    }
  }

  navigateTo(path: string): void {
    console.log('navigaet', path);
    this.router.navigate([path]);
  }
}
 
